
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns72789b467f34749c1b9093b3ac9fb64ben from './en.yaml'
            i18n.addResourceBundle('en', '72789b467f34749c1b9093b3ac9fb64b', flattenObject(ns72789b467f34749c1b9093b3ac9fb64ben), true, true);
        
        export default '72789b467f34749c1b9093b3ac9fb64b';
    